module.exports = ".po-label {\n  min-width: 250px;\n  margin-right: 24px;\n  display: -ms-inline-grid;\n  display: inline-grid; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor/my-vendor/purchase-order-view/po-detail/po-detail.component.scss
// module id = ./src/app/pages/vendor/my-vendor/purchase-order-view/po-detail/po-detail.component.scss
// module chunks = main